require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-brandy-rhodes.json") })
        }
      }, "path---blog-author-brandy-rhodes");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-brandy-rhodes!./.cache/json/blog-author-brandy-rhodes.json
// module id = 606
// module chunks = 231608221292675